// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zKTiC","col":"styles_col__fk7xb"};